import { render, staticRenderFns } from "./MenuBarInvest.vue?vue&type=template&id=270d9fb5&scoped=true&"
import script from "./MenuBarInvest.vue?vue&type=script&lang=js&"
export * from "./MenuBarInvest.vue?vue&type=script&lang=js&"
import style0 from "./MenuBarInvest.vue?vue&type=style&index=0&id=270d9fb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d9fb5",
  null
  
)

export default component.exports